import React, { useEffect, useState } from "react";
import "./TrusteeMembers.css";
import banner from "../Images/about-banner.jpeg" // same banner for consistency
import venuImg from "../Images/venu-kumar.webp"; // Dr. Venu Kumar image
import bhavarajuImg from "../Images/bhavaraju-srinivasa.webp"; // Principal Advisor image
import kavithaImg from "../Images/maddela-kavitha.webp"; // Admin Manager image
import Navbar from "../Home/Navbar";
import Footer from "../Home/Footer";

const TrusteeMembers = () => {

      const [bannerImage, setBannerImage] = useState(""); // Store banner image URL
  
    useEffect(() => {
      // Fetch banner data from API
      fetch("https://api.garudasena.org/api/banners")
        .then((response) => response.json())
        .then((data) => {
          // Find the banner for the "About Us" section
          const aboutUsBanner = data.find((banner) => banner.section === "About Us");
          if (aboutUsBanner) {
            setBannerImage(aboutUsBanner.image); // Set the banner image URL
          }
        })
        .catch((error) => console.error("Error fetching banner data:", error));
    }, []);

  const trustees = [
    { name: "Rajani Priya Chukkala", role: "Trustee" },
    { name: "Kishore Kumar Chukkala", role: "Trustee" },
    { name: "Sireesha Chukkala", role: "Trustee" },
  ];

  const coreTeam = [
    { name: "Bhaskara Rao Ghantasala", role: "Core Team" },
  ];

  return (
       <>
      <Navbar />
    <div className="trustee-page">
      {/* 🏞️ Banner Section */}
      <section className="trustee-banner">
        <img src={bannerImage} alt="Trustee Members" className="banner-image" />
        <div className="banner-overlay">
          <h1>Trustee Members</h1>
          <p>Guided by Faith • Driven by Service</p>
        </div>
      </section>

   {/* 🌿 Founder Chairman */}
<section className="trustee-section container">
  <h2>Founder Chairman</h2>
  <div className="member-card center founder-card">
    <img src={venuImg} alt="Dr. Venu Kumar Chukkala" />
    <h3>Dr. Venu Kumar Chukkala</h3>
    <p>Founder & Chairman</p>
  </div>
</section>

{/* 🕊 Trustees */}
<section className="trustee-section container">
  <h2>Trustees</h2>
  <div className="member-grid">
    {trustees.map((t, index) => (
      <div className="member-card" key={index}>
        <div className="avatar-placeholder">
          <span>{t.name.charAt(0)}</span>
        </div>
        <h3>{t.name}</h3>
        <p>{t.role}</p>
      </div>
    ))}
  </div>
</section>

{/* ⚙️ Leadership Team (3 Cards in a Row) */}
<section className="trustee-section container">
  <h2>Leadership Team</h2>
  <div className="leadership-grid">
    <div className="member-card">
      <div className="avatar-placeholder">
        <span>B</span>
      </div>
      <h3>Bhaskara Rao Ghantasala</h3>
      <p>Core Team</p>
    </div>

    <div className="member-card">
      <img src={bhavarajuImg} alt="Sri Bhavaraju Srinivasa Rao" />
      <h3>Sri Bhavaraju Srinivasa Rao</h3>
      <p>Principal Advisor</p>
    </div>

    <div className="member-card">
      <img src={kavithaImg} alt="Ms. Maddela Kavitha" />
      <h3>Ms. Maddela Kavitha</h3>
      <p>Admin Manager</p>
    </div>
  </div>
</section>

    </div>
      <Footer/>
        </>
  );
};

export default TrusteeMembers;
